var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6714_3213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.83058C6.65973 2.83058 2.33058 7.15973 2.33058 12.5C2.33058 17.8403 6.65973 22.1694 12 22.1694C17.3403 22.1694 21.6694 17.8403 21.6694 12.5C21.6694 7.15973 17.3403 2.83058 12 2.83058ZM0.181824 12.5C0.181824 5.973 5.473 0.681824 12 0.681824C18.527 0.681824 23.8182 5.973 23.8182 12.5C23.8182 19.027 18.527 24.3182 12 24.3182C5.473 24.3182 0.181824 19.027 0.181824 12.5Z",
    fill: "#ECF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33058 12.5C2.33058 7.15973 6.65973 2.83058 12 2.83058C17.3403 2.83058 21.6694 7.15973 21.6694 12.5C21.6694 17.8403 17.3403 22.1694 12 22.1694C6.65973 22.1694 2.33058 17.8403 2.33058 12.5Z",
    fill: "#ECF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3859 9.75759L10.3184 17.825H9.28122L5.6142 14.158L6.65139 13.1208L9.79982 16.2693L17.3487 8.7204L18.3859 9.75759Z",
    fill: "#43A047"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6714_3213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e2db841e4def725b1099444ded4ce360.svg";
export { ForwardRef as ReactComponent };